import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import { Container } from "@mui/material";
import Loading from "../../components/Loading";
import VolverButton from "../../components/VolverButton";
import GestionStaff from "../../components/staff/GestionStaff";
import withAuthenticationRequired from "../../components/ProtectedRoutes/withAuthenticationRequired";
import useEventoStore from "../../stores/useEventoStore";
import { ROL } from "../../domain/staff/roles";

/* Panel de staff de un evento ya creado. Todos lo ven; sólo el owner agrega,
 * edita, quita miembros y asigna PIN (el backend exige lo mismo). */
const Staff = () => {
  const { id } = useParams();
  const userRole = useEventoStore(
    (state) => state.eventosPorId[id]?.data?.eventoUsuario?.idrol ?? null
  );

  useEffect(() => {
    document.title = "Staff | PassGo";
  }, []);

  return (
    <Container>
      <GestionStaff eventoId={id} puedeGestionar={userRole === ROL.OWNER} />

      <div style={{ display: "flex", justifyContent: "flex-end", marginTop: "20px" }}>
        <VolverButton />
      </div>
    </Container>
  );
};

export default withAuthenticationRequired(Staff, {
  onRedirecting: () => <Loading />,
});
